<template>
  <div class="row webshop-setting-item">
    <div class="col-md-12 mt-3 mb-1 head">
      <div class="row d-flex align-items-center">
        <div class="col-md-3 head-toggler">
          <toggle-simple labelEnable="" margins="mb-0" labelDisable="" :checked="isChecked" @toggle="handleChange($event, 'webshop')"></toggle-simple>
        </div>

        <div class="col-md-5 head-title">{{ title }}</div>

        <div class="col-md-3 head-price-input">
          <!-- <text-input-group
            id="price"
            name="price"
            label=""
            :default_value="price"
            inlinerows="false"
            classes="bg-gray gray-border-top gray-border-left gray-border-bottom"
            margins="mb-0"
            btn_fa=""
            btn_label="SEK"
            btn_variant="box-background-grey"
            btn_classes="mb-0"
            btn_width="100%"
            :btn_inputGroup="true"
            :ref="price"
            @input="handleChange($event, 'price')"
          ></text-input-group> -->

          <selector-input-group :selectValues="webshopCurrencies" valuefield="currency_id" textfield="currency_name" :default_value="price" :selectedOption="webshop ? webshop.currency : 'SEK'" @onInput="handleChange($event, 'price')" @onSelect="handleChange($event, 'currency')"> </selector-input-group>
        </div>

        <div class="col-md-1">
          <my-button v-b-toggle="'collapse-' + id" :fa="icons" fapos="right" label="" variant="icon-transparent" classes="mr-1 mb-0" height="56px" width="100%" type="button" @onClick="onToggleClick"></my-button>
        </div>
      </div>
    </div>
    <div class="col-md-12 body">
      <b-collapse :id="'collapse-' + id" class="mt-2">
        <div class="row row-data">
          <div class="col-auto image-holder">
            <img :src="thumbImage" alt="" />
          </div>
          <div class="col body-info-holder">
            <div class="row description">
              <div class="col-md-12">
                <p v-html="summary"></p>
              </div>
            </div>
            <div class="row actions">
              <div class="col-auto">
                <my-button fa="clock-o" fapos="right" label="" variant="icon-gray-round" classes="mr-1 mb-0" height="56px" width="100%" type="button"></my-button>
              </div>
              <div class="col-auto">
                <div class="row timer">{{ totalDuration }}</div>
                <div class="row timer-info">{{ $t(LangConstants.approximation_time_text) }}</div>
              </div>

              <div class="col-md-4">
                <multi-selector id="country-sel" name="country-sel" mandatory="true" label="" :placeholder="$t(LangConstants.languages_placeholder)" tagplaceholder="" valuefield="id" :data="languageList" inlinerows="false" classes="bg-gray" :selected="selectedLanguages" @input="onLanguageSelect"></multi-selector>
              </div>

              <div v-if="woocommerceIntegration == true" class="col-md-auto">
                <my-input id="" name="my-name" mandatory="true" label="" :placeholder="$t(LangConstants.external_id)" inlinerows="false" v-model="externalId" :defaultText="externalId" classes="bg-gray" type="text" @input="handleChange($event, 'external_id')"></my-input>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>

    <div class="col-12 text-left ml-3 mr-3" v-if="isActive">
      <small>
        <a href="javascript:voic(0)" @click="copyToClipBoard(previewURL)"><b>{{ $t(LangConstants.webshop_settings_preview_item) }}</b> <i class="fa fa-link" aria-hidden="true"></i></a>
      </small>
    </div>

    <div class="col-md-12">
      <hr />
    </div>
  </div>
</template>

<script>
import "../../assets/scss/webshopsettingsitem.scss";

import MyButton from "../../components/atoms/Button.vue";
import ToggleSimple from "../../components/atoms/ToggleSimple.vue";
import MyInput from "../../components/atoms/Input.vue";
import Common from ".././../functions/index";
import Constants from "../../constants/index";
import MultiSelector from "../../components/atoms/MultiSelector.vue";
import SelectorInputGroup from "../../components/organisms/SelectorInputGroup.vue";

export default {
  name: "web-shop-setting-item",
  setup() {
    return {};
  },
  async created() {
    if (this.webshop != null) {
      if (this.webshop.courseid == 9) {
        // console.log(this.webshop);
      }
    }
  },
  data() {
    return {
      icons: ["caret-up", "caret-down"],
      locales: this.$i18n.availableLocales,
    };
  },

  props: {
    title: {
      default: "",
    },
    languages: {
      default: "",
    },
    duration: {
      default: "",
    },
    summary: {
      default: "",
    },
    thumbnail: {
      default: null,
    },
    id: {
      default: "",
    },
    currency: {
      default: "",
    },
    webshopstatic: {
      default: null,
    },
    webshop: {
      default: null,
    },
    previewURL: {
      default: "",
    },
  },

  methods: {
    copyToClipBoard(data){
        navigator.clipboard.writeText(data);
        this.$bvToast.toast(this.$t(this.LangConstants.iframe_copied_success_text), {
          title: this.$t(this.LangConstants.information_heading),
          autoHideDelay: 2000,
          appendToast: false,
        });
    },
    onToggleClick() {},

    onLanguageSelect(payload) {
      const langs = JSON.stringify(
        payload.map((lang) => {
          return { id: lang.value, name: Common.getLangNameByISOName(lang.value).name, value: lang.value };
        })
      );
      this.handleChange(langs, "languages");
    },

    handleChange(value, column) {
      this.$emit("change", { id: this.$props.id, column, value });
    },
  },

  computed: {
    isActive() {
      // console.log(this.webshopstatic);

      if (this.webshopstatic != null && this.webshopstatic.active) {
        return true;
      }
      return false;
    },
    woocommerceIntegration() {
      const settings = this.$store.getters.generalSettings;

      if (settings.instanceSettings.woocommerce_integration == 1) {
        return true;
      }

      return false;
    },

    selectedLanguages() {
      if (this.$props.webshop == null || this.$props.webshop.languages == undefined) {
        return null;
      }

      return JSON.parse(this.$props.webshop.languages);
    },
    languageList() {
      let langs = this.$props.languages;
      if (langs == null) {
        langs = "";
      }
      langs = langs.split(",");
      if (Array.isArray(langs) && langs.length > 0) {
        return langs.map((lang) => {
          return { id: lang, name: Common.getLangNameByISOName(lang).name, value: lang };
        });
      }

      return [{ id: "en", text: "English (US)", value: "en" }];
    },
    isChecked() {
      if (this.$props.webshop == null || this.$props.webshop == false || (this.$props.webshop && this.$props.webshop.webshop == false)) {
        return false;
      }
      return true;
    },
    thumbImage() {
      if (this.$props.thumbnail == null) {
        return Common.getImagefromContext("placeholder");
      } else {
        return this.$props.thumbnail;
      }
    },
    price() {
      if (this.$props.webshop != null) {
        return this.$props.webshop.price;
      }
      return "";
    },

    externalId() {
      if (this.$props.webshop != null) {
        return this.$props.webshop.external_id;
      }
      return "";
    },

    totalDuration() {
      return Common.timeConvert(this.$props.duration);
    },

    LangConstants() {
      return Constants;
    },

    webshopCurrencies() {
      return this.$store.getters.webshopCurrencies;
    },
  },

  components: {
    MyInput,
    MyButton,
    ToggleSimple,
    MultiSelector,
    SelectorInputGroup,
  },
};
</script>
